import { Injectable } from "@angular/core";
import { IResponse } from "./response.model";
import { TemplateApiService } from "./template-api.service";


export interface IMetadados extends IResponse {

}

@Injectable()
export class MetadadosService extends TemplateApiService<IMetadados> {

    public override setBaseUrl() {
        this.baseUrl = ``;
    }

    public obterMetadadosGreen(green_checkout_id: string) {
        return this.apiService.post('meta-dados-green', { green_checkout_id });
    }
}
